export default "__VITE_ASSET__B2Jfv8N9__"